/*
 *
 *  sagas
 *
 */

import { call, take, put, race, select, all, delay } from "redux-saga/effects"

import {
  LOAD_EMPLOYEE_REQUEST,
  LOAD_PROCESS_STATUS,
  LOAD_RECORDS_META_DATA,
  UPDATE_EMPLOYEE_REQUEST,
  ADD_REQUEST
} from "./constants"

import {
  loadEmployeeRequest,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,
  loadProcessStatus,
  loadProcessStatusSuccess,
  loadProcessStatusError,
  loadEmployeeRequestSuccess,
  loadEmployeeRequestError,
  updateEmployeeRequestSuccess,
  updateEmployeeRequestError,
  addRequestSuccess,
  addRequestError
} from "./actions"

import {
  loadProcessDetails,
  loadEmployeeList,
  loadRecordsMetaData,
  updateEmployeeDetails,
  addEmployeeDetails
} from "./remotes"

import { selectSession } from "../session/selectors"
import { roleIds } from "../../helpers/tools"

function* loadEmployeeRequestSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_EMPLOYEE_REQUEST),
    })

    const { explicitLoad } = load

    const { searchFilter } = explicitLoad || {}
    yield put(loadEmployeeRequest(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadEmployeeList, searchFilter)


        if (result) {
          yield put(loadEmployeeRequestSuccess(result.Data))
    
        } else {
          yield put(loadEmployeeRequestSuccess([]))
          yield put(loadEmployeeRequestError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(loadEmployeeRequestSuccess([]))
        yield put(
          loadEmployeeRequestError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

//Employee request

function* updateEmployeeSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { update } = yield race({
      update: take(UPDATE_EMPLOYEE_REQUEST),
    })
    const { employeeUpdate } = update || {}
    if (update) {
      try {
        yield call(updateEmployeeDetails, employeeUpdate)
        // yield delay(1000)
        yield put(
          updateEmployeeRequestSuccess(
            employeeUpdate,
            "Record Updated Successfully"
          )
        )
        // yield call(redirect)
      } catch (error) {
        yield put(
          updateEmployeeRequestError(
            (error && error.response && error.response.message) ||
              "Update Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* loadProcessSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_PROCESS_STATUS),
    })

    const { explicitLoad } = load

    const { mode } = explicitLoad || {}
    yield put(loadProcessStatus(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadProcessDetails, mode)

        if (result) {
          yield put(loadProcessStatusSuccess(result.data))
        } else {
          yield put(loadProcessStatusError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadProcessStatusError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* loadRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_RECORDS_META_DATA),
    })

    try {
      let sessionDetails
      while (true) {
        // eslint-disable-line no-constant-condition
        const sessionInStore = yield select(selectSession())

        const { user = {} } = sessionInStore
        if (user && Object.keys(user).length > 0) {
          sessionDetails = sessionInStore
          break
        }
        yield delay(500)
      }

      let company
      let branch
      if (
        sessionDetails &&
        sessionDetails.user &&
        roleIds.includes(sessionDetails.user.roleId)
      ) {
        company = yield call(loadRecordsMetaData, "company", "post")
        branch = yield call(loadRecordsMetaData, "branch", "post")
      } else {
        company =
          (sessionDetails &&
            sessionDetails.user &&
            sessionDetails.user.company &&
            sessionDetails.user.company.length > 0 &&
            sessionDetails.user.company.map((_) => _.detail)) ||
          []
        branch =
          (sessionDetails &&
            sessionDetails.user &&
            sessionDetails.user.branch &&
            sessionDetails.user.branch.length > 0 &&
            sessionDetails.user.branch.map((_) => _.detail)) ||
          []
      }
      const employee = yield call(loadRecordsMetaData,
        "employee_filter",
        "post") 
      const department = yield call(loadRecordsMetaData, "department", "post")
      const designation = yield call(loadRecordsMetaData, "designation", "post")
      let recordsMetaData = {
        companyOptions:
          (company &&
            company.data &&
            company.data.length > 0 &&
            company.data.filter(_=> _.status === 1).map((c) =>
              Object.assign({}, { label: c.name, value: c._id })
            )) ||
          (company &&
            company.length > 0 &&
            company.map((c) =>
              Object.assign({}, { label: c.name, value: c._id })
            )) ||
          [],
        branchOptions:
          (branch &&
            branch.data &&
            branch.data.length > 0 &&
            branch.data.filter(_=> _.status === 1).map((c) =>
              Object.assign(
                {},
                { label: c.name, value: c._id, companyId: c.companyId }
              )
            )) ||
          (branch &&
            branch.length > 0 &&
            branch.map((c) =>
              Object.assign(
                {},
                { label: c.name, value: c._id, companyId: c.companyId }
              )
            )) ||
          [],
        departmentOptions:
          (department &&
            department.data &&
            department.data.length > 0 &&
            department.data.filter(_=> _.status === 1).map((c) =>
              Object.assign({}, { label: c.name, value: c._id })
            )) ||
          (department &&
            department.length > 0 &&
            department.map((c) =>
              Object.assign({}, { label: c.name, value: c._id })
            )) ||
          [],
        designationOptions:
          (designation &&
            designation.data &&
            designation.data.length > 0 &&
            designation.data.filter(_=> _.status === 1).map((c) =>
              Object.assign(
                {},
                {
                  label: c.name,
                  value: c._id,
                  code: c.code,
                  departmentId: c.departmentId,
                }
              )
            )) ||
          [],
          
        employeeOptions:
        (employee &&
          employee.data &&
          employee.data.length > 0 &&
          employee.data

            .map((c) =>
              Object.assign(
                {},
                {
                  label: c.empCode.concat(" - ", c.name),
                  value: c._id,
                  code:c.empCode,
                  companyName: c.companyName,
                  branchName:c.branchName,
                  departmentName:c.departmentName,
                  designationName:c.designationName
                }
              )
            )) ||
        [],
      }
      yield put(loadRecordsMetaDataSuccess(recordsMetaData))
    } catch (error) {
      yield put(
        loadRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}
//addRequest

function* addEmployeeSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { update } = yield race({
      update: take(ADD_REQUEST),
    })
    const { request_details } = update || {}
    if (update) {
      try {
        yield call(addEmployeeDetails, request_details)
        // yield delay(1000)
        yield put(
          addRequestSuccess(
            request_details,
            "Record Updated Successfully"
          )
        )
        // yield call(redirect)
      } catch (error) {
        yield put(
          addRequestError(
            (error && error.response && error.response.message) ||
              "Update Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}
export default function* recordsSaga() {
  yield all([
    loadEmployeeRequestSaga(),
    loadRecordsMetaDataSaga(),
    loadProcessSaga(),
    updateEmployeeSaga(),
    addEmployeeSaga()
  ])
}
